"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSocialMediaType = void 0;
var isSocialMediaType = key => {
  return ['instagram', 'youtube', 'soundcloud', 'twitter', 'facebook', 'appleMusic', 'spotify'].includes(key);
};
exports.isSocialMediaType = isSocialMediaType;